import { render, staticRenderFns } from "./MbScuolaSelect.vue?vue&type=template&id=986197a6&scoped=true&"
import script from "./MbScuolaSelect.vue?vue&type=script&lang=js&"
export * from "./MbScuolaSelect.vue?vue&type=script&lang=js&"
import style0 from "./MbScuolaSelect.vue?vue&type=style&index=0&id=986197a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986197a6",
  null
  
)

export default component.exports